import { render, staticRenderFns } from "./top-lock.vue?vue&type=template&id=ba63561e&scoped=true"
import script from "./top-lock.vue?vue&type=script&lang=js"
export * from "./top-lock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba63561e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba63561e')) {
      api.createRecord('ba63561e', component.options)
    } else {
      api.reload('ba63561e', component.options)
    }
    module.hot.accept("./top-lock.vue?vue&type=template&id=ba63561e&scoped=true", function () {
      api.rerender('ba63561e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/top/top-lock.vue"
export default component.exports